export default {
  nav: {
    overview: "概览",
    products: "软件产品",
    licenses: "我的许可证",
    status: "系统状态",
    activity: "最近动态",
    admin: "管理后台",
    quickApply: "快速申请",
    login: "登录 / 注册",
    notifications: "通知中心",
    settings: "个人设置",
    signOut: "退出登录",
    language: "语言",
    adminProducts: "软件产品管理",
    adminTools: "授权工具",
    adminCustomers: "客户管理",
    adminAudit: "审计日志",
    adminMonitor: "监控看板",
    adminStaff: "管理员管理",
    adminReports: "报表中心",
    adminApiKeys: "对接方管理",
    adminApprovals: "审批流与回调",
    adminHelp: "帮助中心反馈",
    brandHome: "LicenseHub 首页",
    openMenu: "打开菜单",
    userMenu: "用户菜单",
  },
  hero: {
    badge: "正版软件授权 · 一站式管理",
    titleLead: "让每一份正版授权",
    titleHighlight: "清晰可控",
    subtitle:
      "从授权申请、许可证生成到状态监控与报表导出，LicenseHub 用一套系统连接客户与管理团队，让授权流转全程可视、可追溯。",
    login: "立即登录",
    apply: "快速申请授权",
    statCustomers: "服务客户",
    statActive: "有效许可证",
    statSeats: "在线席位",
    imgAlt: "LicenseHub 授权管理平台视觉背景",
    imgTitle: "LicenseHub 正版软件授权管理平台",
  },
  overview: {
    active: "有效许可证",
    activeSub: "共 {{total}} 张许可证",
    pending: "待审批申请",
    pendingSub: "需尽快处理",
    issued: "本月新签发",
    issuedSub: "本月内签发的许可证",
    expiring: "即将到期",
    expiringSub: "30 天内到期的有效许可证",
    expiringCta: "查看待续期清单",
    customers: "客户总数",
    customersSub: "累计注册与在册客户",
    customersCta: "前往客户管理",
    pendingCustomers: "待审批客户",
    pendingCustomersSub: "名下有待审批申请的客户",
    pendingCustomersCta: "查看待审批客户",
    seats: "在线席位",
    seatsSub: "当前激活终端",
  },
  status: {
    eyebrow: "系统状态",
    title: "授权运行状态一览",
    description: "实时掌握授权激活趋势、许可证签发情况与平台可用率，异常第一时间可见。",
    trendTitle: "近 30 天授权趋势",
    trendSub: "终端激活量与许可证签发量",
    legendActivation: "激活",
    legendIssued: "签发",
    distTitle: "许可证状态分布",
    distSub: "当前全部许可证构成",
    empty: "暂无数据",
    statRequests: "今日接口请求",
    statUptime: "平均可用率",
    statIssued: "近 30 天签发",
    active: "有效",
    expired: "已过期",
    suspended: "已暂停",
    revoked: "已吊销",
  },
  activity: {
    eyebrow: "最近动态",
    title: "授权流转实时动态",
    description: "审批、发证、激活、告警等关键事件集中呈现，支持按状态筛选并一键导出授权报表。",
    eventStream: "事件流",
    realtime: "实时更新",
    exportBtn: "导出授权报表",
    exporting: "导出中…",
    exportedToast: "已导出 {{num}} 条授权记录",
    exportFailed: "导出失败，请稍后重试",
    filterAll: "全部",
    levelSuccess: "成功",
    levelWarning: "告警",
    levelError: "异常",
    levelInfo: "提示",
    reload: "重新加载",
    empty: "暂无符合条件的动态",
    pendingTitle: "待处理授权申请",
    pendingSub: "及时审批可提升客户授权体验",
    goAdmin: "前往管理后台",
    quickTitle: "快捷入口",
    quickApply: "提交授权申请",
    quickProducts: "软件产品中心",
    quickLicenses: "许可证中心",
    quickMonitor: "状态监控",
    quickHelp: "帮助中心",
    system: "系统",
  },
  help: {
    eyebrow: "帮助中心",
    title: "遇到问题？我们随时帮你",
    description: "从入门到进阶，帮助中心为你提供授权管理的全部使用指导。",
    viewDetail: "查看详情",
    i1Title: "快速入门",
    i1Desc: "三步完成账号注册、授权申请与许可证获取。",
    i2Title: "常见问题",
    i2Desc: "授权范围、席位调整、许可证迁移等高频问题解答。",
    i3Title: "使用文档",
    i3Desc: "面向管理员与客户的完整操作指南与最佳实践。",
    i4Title: "提交工单",
    i4Desc: "遇到授权或发证异常，随时联系技术支持团队。",
    noAnswer: "没有找到答案？",
    contactDesc: "联系我们的授权支持团队，通常 1 个工作日内回复。",
    contact: "联系我们",
  },
  helpCenter: {
    breadcrumbHome: "首页",
    breadcrumbCurrent: "帮助中心",
    badge: "自助服务 · 常见问题 · 接入指南",
    title: "帮助中心",
    subtitle:
      "从注册、申请到领取与激活，再到续期与接口接入，这里汇总了你最常用的操作指引与高频问题解答。",
    searchPlaceholder: "搜索问题关键词，例如「续期」「机器码」「429」…",
    searchClear: "清除",
    heroSearchLabel: "搜索帮助中心",
    heroSearchButton: "搜索",
    heroSearchHot: "热门搜索",
    hotTag1: "激活",
    hotTag2: "续期",
    hotTag3: "机器码",
    hotTag4: "429",
    hotTag5: "接口接入",
    navQuickstart: "快速入门",
    navFaq: "常见问题",
    navDocs: "接入文档",
    navContact: "联系支持",
    quickEyebrow: "快速入门",
    quickTitle: "四步走完一次授权",
    quickDesc: "按顺序完成下列步骤，即可从注册一路走到设备激活。",
    quickStepTag: "STEP {{num}}",
    step1Title: "创建账号",
    step1Desc: "点击右上角「登录 / 注册」，用邮箱完成注册后登录平台。",
    step1Cta: "去登录 / 注册",
    step2Title: "提交授权申请",
    step2Desc: "选择产品与版本，填写席位数量与设备机器码等信息。",
    step2Cta: "去提交申请",
    step3Title: "等待平台审批",
    step3Desc: "通常 1-2 个工作日内完成核验，结果以邮件与站内通知送达。",
    step3Cta: "查看我的申请",
    step4Title: "领取并激活许可证",
    step4Desc: "在许可证中心复制密钥或下载文件，录入机器码完成激活。",
    step4Cta: "前往许可证中心",
    faqEyebrow: "常见问题",
    faqTitle: "高频问题解答",
    faqDesc: "按分类浏览，或直接搜索关键词，快速定位你遇到的问题。",
    faqAll: "全部",
    faqCatAccount: "账号与登录",
    faqCatApply: "授权申请",
    faqCatLicense: "许可证与激活",
    faqCatRenewal: "到期与续期",
    faqCatIntegration: "接入与对接",
    faqResultCount: "共 {{count}} 条相关解答",
    faqRecentTitle: "最近浏览的问题",
    faqRecentClear: "清除记录",
    faqCopyLink: "复制搜索链接",
    faqLinkCopied: "链接已复制",
    faqEmpty: "没有找到匹配的问题",
    faqEmptyDesc: "换个关键词试试，或直接提交工单，由支持团队协助你。",
    faqReset: "重置筛选",
    faqContactCta: "没找到答案？提交工单",
    faqCopyItem: "复制该问题链接",
    faqItemLinkCopied: "问题链接已复制",
    faqHelpfulQuestion: "这条解答对你有帮助吗？",
    faqHelpful: "有帮助",
    faqNotHelpful: "没帮助",
    faqFeedbackThanks: "感谢反馈",
    faqNotHelpfulHint: "已跳到下方工单，并为你预填问题类型",
    faqRecentBadge: "最近浏览",
    faqRecentlyUpdated: "最近更新",
    faqRecentlyUpdatedTitle: "这条解答最近被更新过（{{time}}）",
    q1: "如何注册账号并登录？",
    a1: "点击页面右上角「登录 / 注册」，用邮箱完成注册后即可登录；已有账号直接登录即可。",
    q2: "忘记密码了怎么办？",
    a2: "在登录页点击「忘记密码」，填写注册邮箱，我们会发送重置链接，按提示设置新密码。",
    q3: "收不到邮件通知怎么办？",
    a3: "请先检查垃圾邮件目录，并确认账号邮箱填写正确；若仍收不到，可通过下方工单联系我们核对发送状态。",
    q4: "如何提交授权申请？",
    a4: "点击顶部「快速申请」，选择产品与版本，填写席位数量、机器码与使用场景后提交即可。",
    q5: "申请多久能审批通过？",
    a5: "一般在 1-2 个工作日内完成核验；提交后可在「我的许可证」或申请页的「我的申请」中实时跟踪进度。",
    q6: "机器码在哪里查看？",
    a6: "打开目标软件，在「帮助 → 授权信息」中查看并复制机器码；席位数量请按实际部署设备数填写。",
    q7: "席位数量应该填多少？",
    a7: "按实际需要激活的设备台数填写；审批通过后系统会按该数量生成许可证席位。",
    q8: "审批通过后如何领取许可证？",
    a8: "审批通过后会自动签发，进入「我的许可证」即可查看密钥、复制密钥或下载许可证文件。",
    q9: "如何激活一台新设备？",
    a9: "打开许可证的「设备激活明细」，点击「激活新设备」，录入机器码（可选设备名、系统、位置）后确认即可。",
    q10: "换电脑了需要重新购买吗？",
    a10: "不需要。先在旧设备上「解除激活」，再在新设备上录入新机器码激活即可，名额会随之释放与占用。",
    q11: "提示「激活名额已满」怎么办？",
    a11: "请先解绑不再使用的设备释放名额；若确实需要更多席位，请提交增加席位的授权申请。",
    q12: "许可证快到期会有提醒吗？",
    a12: "会。我们会在到期前通过站内通知与邮件提醒你，也可在「我的许可证」的到期规划中查看临期清单。",
    q13: "如何申请续期？",
    a13: "在许可证卡片点击「申请续期」，填写期望时长后提交；审批通过后有效期会自动顺延。",
    q14: "过期之后还能继续使用吗？",
    a14: "过期后授权校验会返回失效，客户端将无法放行，请尽快完成续期以避免影响使用。",
    q15: "如何接入网络验证接口？",
    a15: "先在「管理后台 → 对接方管理」签发 API Key，再按「接入文档」调用校验接口，客户端只需判断返回的 valid 字段。",
    q16: "无网络环境怎么授权？",
    a16: "使用「离线一机一码」方案：后台用私钥离线签名生成激活码，软件内置公钥在本地验签，全程无需联网。",
    q17: "调用接口返回 429 或提示限流？",
    a17: "说明触发了密钥的限流或每日配额，请在「对接方管理」中调整该密钥的限流与配额，或错峰调用。",
    guidesEyebrow: "使用教程",
    guidesTitle: "精选指南与最佳实践",
    guidesDesc: "几条把授权用顺、用稳的经验之谈，点开即可前往对应模块。",
    guide1Title: "三分钟完成首次授权申请",
    guide1Desc: "从选产品到填机器码，手把手带你走通第一份申请。",
    guide1Tag: "入门",
    guide2Title: "许可证密钥安全保管指南",
    guide2Desc: "密钥属于敏感信息，如何存储与分发才不踩坑。",
    guide2Tag: "安全",
    guide3Title: "设备迁移与席位回收",
    guide3Desc: "换机、报废时如何解绑旧设备，把名额留给新机器。",
    guide3Tag: "运维",
    guide4Title: "到期续期规划",
    guide4Desc: "用好到期规划器，提前安排续期，避免授权中断。",
    guide4Tag: "续期",
    guide5Title: "网络验证接口接入要点",
    guide5Desc: "签发 API Key、处理限流与失败码的正确姿势。",
    guide5Tag: "接入",
    guide6Title: "离线一机一码：无网环境授权",
    guide6Desc: "完全离线的场景下，用公钥本地验签的落地方案。",
    guide6Tag: "进阶",
    guideOpen: "查看指引",
    docsTitle: "面向开发者的接入文档",
    docsDesc: "网络验证接口、请求与返回字段、结果码，以及离线一机一码的本地验签参考实现，都在这里。",
    docsBtn: "查看接入文档",
    contactEyebrow: "提交工单",
    contactTitle: "还没有解决？联系我们",
    contactDesc: "填写下面的工单，授权支持团队通常会在 1 个工作日内回复你。",
    contactPoint1Title: "响应时效",
    contactPoint1Desc: "工作日 1 个工作日内回复",
    contactPoint2Title: "支持范围",
    contactPoint2Desc: "授权申请、发证、激活与续期问题",
    contactPoint3Title: "优先自助",
    contactPoint3Desc: "先看上方 FAQ 与指南，多数问题可自助解决",
    formSuggestTitle: "先看看这些解答，可能已有答案",
    formSuggestHint: "以下是与该问题类型最相关的解答，可先自助尝试；仍无法解决再提交工单。",
    formSuggestMore: "查看全部常见问题",
    formName: "您的姓名",
    formNamePlaceholder: "请输入姓名",
    formEmail: "联系邮箱",
    formEmailPlaceholder: "you@example.com",
    formCompany: "公司 / 组织（选填）",
    formCompanyPlaceholder: "请输入公司或组织名称",
    formType: "问题类型",
    formTypePlaceholder: "请选择问题类型",
    formTypeAccount: "账号与登录",
    formTypeApply: "授权申请",
    formTypeLicense: "许可证与激活",
    formTypeRenewal: "到期与续期",
    formTypeIntegration: "接入与对接",
    formTypeOther: "其他问题",
    formLicense: "相关许可证密钥（选填）",
    formLicensePlaceholder: "例如 LH-XXXX-XXXX-XXXX-XXXX",
    formContent: "问题描述",
    formContentPlaceholder: "请描述你遇到的问题、期望的结果，以及已经尝试过的操作（不超过 500 字）",
    formSubmit: "提交工单",
    formSubmitting: "提交中…",
    formNote: "提交即表示你同意我们通过填写的邮箱与你联系。",
    formSuccessTitle: "工单已提交",
    formSuccessDesc: "我们已收到你的问题，支持团队会在 1 个工作日内通过邮箱回复你。",
    formAnother: "再提交一份",
    formErrName: "请填写您的姓名",
    formErrEmail: "请填写联系邮箱",
    formErrEmailFormat: "邮箱格式不正确",
    formErrType: "请选择问题类型",
    formErrContent: "请填写问题描述",
    formErrContentMax: "问题描述不能超过 500 字",
    formErrFailed: "提交失败，请稍后重试",
  },
  footer: {
    tagline: "一站式正版软件授权管理平台，从申请、审批、发证到监控与报表，让每一份授权都清晰可控。",
    badgeSecurity: "安全合规",
    badgeUptime: "高可用 99.9%",
    colProduct: "产品",
    colHelp: "帮助中心",
    colSupport: "获取支持",
    productApply: "授权申请",
    productLicenses: "许可证中心",
    productMonitor: "状态监控",
    productReports: "报表导出",
    helpGuide: "快速入门",
    helpFaq: "常见问题",
    helpDocs: "接入文档",
    helpTicket: "提交工单",
    supportDesc: "遇到授权或发证问题，帮助中心随时为你解答。",
    supportBtn: "前往帮助中心",
    copyright: "© 2026 LicenseHub 授权管理平台. 保留所有权利。",
    terms: "服务条款",
    privacy: "隐私政策",
    contact: "联系我们",
  },
  licenses: {
    breadcrumbHome: "首页",
    title: "我的许可证",
    subtitle: "查看你名下的全部许可证，复制密钥、确认状态与到期时间，并跟踪设备激活情况。",
    applyNew: "申请新授权",
    reload: "重新加载",
    filterAll: "全部",
    filterActive: "有效",
    filterExpiring: "即将到期",
    filterExpired: "已过期",
    filterInactive: "已暂停 / 吊销",
    sourceLabel: "来源",
    sourceAll: "全部来源",
    sourceApplication: "审批发证",
    sourceRedeem: "激活码核销",
    emptyTitle: "你还没有任何许可证",
    emptyTitleFiltered: "该分类下暂无许可证",
    emptyDesc: "提交一份授权申请，审批通过后许可证会自动出现在这里。",
    emptyDescFiltered: "换个筛选条件看看其它状态的许可证。",
    emptyApply: "立即申请授权",
    tip: "许可证密钥属于敏感信息，请勿在公开渠道分享。如需迁移设备或增加席位，可随时提交新的授权申请。",
    seatUnit: "{{count}} 席位",
    sourceTipApplication: "通过授权申请审批发证",
    sourceTipRedeem: "通过原始激活码自助核销获得",
    licenseKeyLabel: "许可证密钥",
    show: "显示",
    hide: "隐藏",
    copyKey: "复制密钥",
    copied: "已复制",
    deviceDetail: "设备激活明细",
    deviceDetailHint: "点击查看已激活设备，可自助激活新设备、解绑换机",
    issuedAt: "签发 {{date}}",
    expiresAt: "到期 {{date}}",
    permanent: "永久",
    expiringOnlyDays: "仅剩 {{days}} 天到期",
    expiredRenew: "已过期，请续期",
    cardHint: "可下载许可证文件，或在临期 / 过期时申请续期。",
    downloadSuccess: "已下载许可证文件 {{file}}",
    downloadFailed: "下载失败，请稍后重试",
    downloaded: "已下载",
    downloadFile: "下载许可证文件",
    renewSubmitted: "续期申请已提交",
    renew: "申请续期",
    renewSuccess: "已提交续期申请，平台审批通过后将自动顺延有效期",
    submitFailed: "提交失败，请稍后重试",
    statTotal: "许可证总数",
    statTotalHint: "随来源筛选联动",
    statActive: "有效中",
    statExpiring: "30 天内到期",
    statSeats: "授权席位合计",
    statRedeemPct: "激活码核销占比",
    statRedeemHint: "{{redeem}} 张核销 · {{application}} 张审批",
    statRedeemCta: "点击筛选核销来的许可证",
    statRedeemActive: "已筛出核销来的许可证 · 下方按批次拆分",
    redeemTitle: "核销激活码",
    redeemDesc: "拿到分发到手的原始激活码（形如 XXXX-XXXX-XXXX-XXXX）？在这里输入即可自动生成一张专属许可证，并写入下方列表。",
    redeemOnce: "一次性核销",
    redeemPlaceholder: "XXXX-XXXX-XXXX-XXXX",
    redeemSubmit: "立即核销",
    redeemSubmitting: "核销中…",
    redeemEmptyCode: "请输入激活码",
    redeemFailed: "核销失败，请稍后重试",
    redeemSuccessTitle: "核销成功，许可证已写入你的账户",
    redeemProduct: "产品",
    redeemEdition: "版本",
    redeemSeats: "席位",
    redeemTip: "每张激活码仅能核销一次，核销后即绑定到当前账号。若提示「已被核销」或「已停用」，请联系发码方处理。",
    breakdownTitle: "核销来源 · 按批次拆分",
    breakdownSub: "看每个批次各贡献了多少张通过激活码核销来的许可证。",
    breakdownSortCount: "按张数",
    breakdownSortRecent: "最近核销",
    breakdownSortCountTitle: "按核销张数从多到少排序",
    breakdownSortRecentTitle: "把最近有核销动作的批次排到最前",
    breakdownTotal: "共 {{count}} 张 · {{batches}} 个批次",
    breakdownProduct: "产品",
    breakdownAllProducts: "全部产品",
    breakdownLoading: "批次分布加载中…",
    breakdownEmpty: "暂无可按批次拆分的核销来源。",
    breakdownLastRedeemed: "最近核销：{{time}}",
    breakdownNeverRedeemed: "尚无核销",
    breakdownLastExport: "最近导出：{{who}} · {{date}}",
    breakdownCopy: "复制该批次核销清单",
    breakdownCopied: "已复制清单",
    breakdownCopyTitle: "复制该批次已核销的许可证清单，可直接粘贴到表格做台账",
    breakdownDownload: "下载该批次 CSV",
    breakdownDownloaded: "已下载清单",
    breakdownDownloadTitle: "下载该批次已核销许可证的正式 CSV，文件名含批次号与日期",
    breakdownCountUnit: "{{count}} 张",
    breakdownFilterByProduct: "只看「{{name}}」的核销贡献",
    breakdownGenericProduct: "通用授权",
    batchListHeader: "批次 {{batch}} 核销清单 · 共 {{count}} 张",
    colLicenseKey: "许可证密钥",
    colProduct: "产品",
    colEdition: "版本",
    colSeats: "授权席位",
    colRedeemedAt: "核销时间",
    redeemedFilePrefix: "已核销许可证清单",
    renewalTitle: "申请续期",
    renewalDesc: "提交后平台将收到你的续期申请，审批通过后会自动顺延该许可证的有效期。",
    renewalCurrentExpiry: "当前到期",
    renewalExpiredSuffix: "（已过期）",
    renewalNoteLabel: "续期说明 / 期望时长（选填）",
    renewalNotePlaceholder: "例如：希望续期 12 个月，用于 2026 年新项目",
    cancel: "取消",
    renewalSubmit: "提交续期申请",
    renewalSubmitting: "提交中…",
    plannerTitle: "到期规划",
    plannerSub: "按紧迫度把你名下的许可证分组，提前安排续期，避免授权中断。",
    plannerOverdue: "已过期",
    plannerUrgent: "30 天内到期",
    plannerSoon: "90 天内到期",
    plannerLater: "90 天以上",
    plannerPerpetual: "永久有效",
    plannerCount: "{{count}} 张",
    plannerEmpty: "暂无需要规划的到期项",
    plannerEmptyDesc: "当你拥有临近到期的许可证时，这里会自动帮你排好续期优先级。",
    plannerNext: "最近到期",
    plannerDaysLeft: "{{days}} 天后到期",
    plannerOverdueDays: "已过期 {{days}} 天",
    plannerView: "查看",
    plannerExport: "导出续期清单",
    plannerExported: "已导出",
    plannerExportTitle: "把需要续期的许可证导成 CSV，方便做续期台账",
    plannerExportFileName: "续期清单",
    plannerColProduct: "产品",
    plannerColEdition: "版本",
    plannerColKey: "许可证密钥",
    plannerColExpiry: "到期日",
    plannerColDaysLeft: "剩余天数",
    plannerColStatus: "状态",
    plannerColUrgency: "紧迫度",
  },
  timeline: {
    title: "许可证变更时间线",
    sub: "签发、续期与设备变更按时间倒序统一回放，方便追溯每一次授权变动。",
    toggleShow: "展开时间线",
    toggleHide: "收起时间线",
    filterAll: "全部",
    filterNoMatch: "该类型下暂无变更记录",
    count: "{{count}} 条变更",
    typeIssued: "签发许可证",
    typeRenewed: "续期",
    typeActivated: "激活设备",
    typeReleased: "解绑设备",
    empty: "暂无变更记录",
    emptyDesc: "当许可证签发、续期或设备激活 / 解绑后，变更会按时间回放到这里。",
    licenseTag: "许可证",
    deviceTag: "设备",
    loadFailed: "变更记录加载失败，请稍后重试",
  },
  edition: {
    standard: "标准版",
    professional: "专业版",
    enterprise: "企业版",
  },
  licenseStatus: {
    active: "有效",
    expired: "已过期",
    suspended: "已暂停",
    revoked: "已吊销",
  },
  licenseSource: {
    application: "审批发证",
    redeem: "用激活码核销",
  },
  time: {
    justNow: "刚刚",
  },
  device: {
    panelTitle: "设备激活明细 · {{product}}",
    summary: "已激活 {{active}} 台，上限 {{max}} 台，剩余 {{left}} 个名额。录入机器码即可自助激活，换机时先解绑旧设备再激活新设备。",
    activateNew: "激活新设备",
    activateSeatsUsed: "激活名额已用完，请先解绑其它设备",
    activateTitle: "录入机器码激活新设备",
    exportList: "导出设备清单",
    exported: "已导出",
    exportEmpty: "暂无设备可导出",
    exportTitle: "导出当前许可证的设备清单 CSV",
    cleanInactive: "清理非活跃",
    cleanNoInactive: "没有超过 {{days}} 天未活跃的设备",
    cleanTitle: "解绑 {{count}} 台 {{days}} 天以上未活跃的设备，回收名额",
    close: "收起设备明细",
    cleanConfirm: "将解绑 {{count}} 台连续 {{days}} 天以上未活跃的设备，释放的名额可立即用于新设备。此操作会写入操作动态，可在时间线中回看。",
    cancel: "取消",
    cleaning: "清理中…",
    confirmUnbind: "确认解绑 {{count}} 台",
    activateForm: "录入机器码激活 · 剩余名额 {{left}} 台",
    machineCode: "机器码",
    machineCodePlaceholder: "例如 9A2F-77C1-B3D4-005E",
    deviceName: "设备名称（选填）",
    deviceNamePlaceholder: "例如 张三的办公机",
    os: "操作系统（选填）",
    osPlaceholder: "例如 Windows 11 / macOS 14",
    location: "使用地点（选填）",
    locationPlaceholder: "例如 上海 · 研发中心",
    confirmActivate: "确认激活",
    activating: "激活中…",
    statusAll: "全部",
    statusActive: "已激活",
    statusReleased: "已解绑",
    timeAll: "全部时间",
    time7d: "近 7 天",
    time30d: "近 30 天",
    summaryCount: "共 {{total}} 台 · 筛选后 {{filtered}} 台",
    reload: "重新加载",
    emptyNoDevice: "暂无已激活设备",
    emptyNoMatch: "没有符合筛选条件的激活设备",
    emptyNoDeviceDesc: "点击上方「激活新设备」录入机器码，或在软件中使用许可证密钥激活。",
    emptyNoMatchDesc: "调整上方状态或时间筛选再试试。",
    save: "保存",
    rename: "重命名设备",
    lastSeen: "最近活跃 {{time}}",
    confirmRelease: "确认解除该设备激活？",
    confirmReleaseBtn: "确认解除",
    processing: "处理中…",
    releaseBtn: "解除激活",
    timelineTitle: "激活 / 解绑时间线（{{count}}）",
    batchClean: "系统批量清理 · 回收 {{count}} 台",
    batchTag: "批次",
    expandBatch: "展开查看本次清理回收的设备",
    jumpDevice: "跳转到该设备",
    eventRelease: "解除设备激活",
    eventActivate: "激活设备",
    tagSelfRelease: "自助解绑",
    tagSelfActivate: "自助激活",
    releasedDevices: "已解绑设备（{{count}}）",
    sourceBatch: "系统批量清理",
    sourceSelf: "自助解绑",
    releaseSuccess: "已解除「{{name}}」的激活，名额已释放",
    releaseFailed: "解除失败，请稍后重试",
    renameSuccess: "设备名称已更新",
    renameFailed: "重命名失败，请稍后重试",
    needMachineCode: "请填写设备机器码",
    activateSuccess: "设备已激活，剩余名额 {{left}} 台",
    activateFailed: "激活失败，请稍后重试",
    cleanSuccess: "已解绑 {{count}} 台非活跃设备，回收 {{count}} 个名额",
    cleanNone: "当前没有符合条件的非活跃设备",
    cleanFailed: "批量解绑失败，请稍后重试",
    colDevice: "设备名称",
    colMachine: "机器码",
    colOs: "操作系统",
    colLocation: "使用地点",
    colStatus: "状态",
    colActivated: "激活时间",
    colLastSeen: "最近活跃",
    colReleased: "解绑时间",
    colReleaseSource: "解绑来源",
    csvFileName: "设备清单",
  },
  tools: {
    breadcrumbHome: "首页",
    breadcrumbAdmin: "管理后台",
    badge: "发证效率工具",
    title: "授权工具",
    subtitle: "批量生成一次性「原始激活码」用于分发，或为不联网场景生成「离线一机一码」激活码；所有操作都会写入审计日志。",
    docs: "查看接入文档",
    reload: "重新加载",
    tabPool: "原始激活码池",
    tabOffline: "离线一机一码",
  },
  adminHome: {
    breadcrumbHome: "首页",
    badge: "管理员控制台",
    title: "授权管理后台",
    subtitle: "统一审批授权申请、一键生成与吊销许可证，审批通过后自动签发密钥并邮件通知申请人。",
    pendingPrefix: "当前有",
    pendingSuffix: "条申请待审批",
    exportAll: "导出全部许可证报表",
    exportEmpty: "当前没有可导出的许可证",
    exportDone: "已导出 {{num}} 条许可证记录（含已吊销）",
    reload: "重新加载",
    tabApplications: "申请审批",
    tabLicenses: "许可证管理",
    tip: "审批通过时会自动生成许可证密钥，并向申请人邮箱发送通知。若邮件未发出，请确认已在「邮件发送」中完成 Resend 域名配置。",
    moduleProducts: "软件产品管理",
    moduleTools: "授权工具",
    moduleReports: "报表中心",
    moduleCustomers: "客户管理",
    moduleAudit: "审计日志",
    moduleMonitor: "监控看板",
    moduleStaff: "管理员管理",
    moduleApiKeys: "对接方管理",
    moduleApprovals: "审批流与回调",
    moduleHelp: "帮助中心反馈",
  },
  reports: {
    breadcrumbHome: "首页",
    breadcrumbAdmin: "管理后台",
    title: "报表中心",
    badge: "统一导出入口",
    subtitle: "把散落在各处的 CSV 导出收口成一个入口：可直接生成的报表一键出文件，依赖筛选条件的报表给出跳转；每一次导出都会留下可追溯的任务历史。",
    backToAdmin: "返回管理后台",
    reload: "重新加载",
    statTotal: "累计导出任务",
    statMonth: "本月导出",
    statRunnable: "可一键生成",
    statRows: "累计导出行数",
    batchTitle: "批量导出",
    batchSubtitle: "勾选多份报表一次性打包生成，并汇总为一条导出任务，便于归档与月度审计。",
    batchSelectAll: "全选",
    batchClear: "清空",
    batchSelected: "已选 {{count}} 份",
    batchGenerate: "批量生成 {{count}} 份报表",
    batchRunning: "批量生成中…",
    batchEmpty: "请先勾选要导出的报表",
    batchDone: "已完成 {{count}} 份报表，共 {{rows}} 行",
    batchFailed: "批量导出失败，请稍后重试",
    batchConfirmTitle: "确认批量导出范围",
    batchConfirmSub: "以下 {{count}} 份报表将一次性生成，请确认名称与预计行数，避免误触大范围导出。",
    batchConfirmEstimate: "约 {{rows}} 行",
    batchConfirmTotalLabel: "合计预计行数",
    batchConfirmTotal: "约 {{rows}} 行",
    batchConfirm: "确认导出",
    batchCancel: "取消",
    batchConfirmLargeTitle: "预计行数偏高",
    batchConfirmLargeBody: "本次批量导出合计约 {{rows}} 行，范围偏大、生成可能需要较长时间。请确认确有必要一次性导出这么大范围，或取消部分勾选后再试。",
    healthWindowTitle: "健康快照时间窗口",
    healthWindowHint: "回调端点健康快照按所选窗口生成；单份「生成」与「批量导出」共用同一窗口，导出留痕会带窗口标识。",
    healthWindowInlineLabel: "时间窗口",
    catalogRunnable: "{{category}}报表",
    catalogCount: "共 {{count}} 份，可一键生成",
    catalogLinksTitle: "更多导出 · 前往对应模块",
    catalogLinksSub: "带筛选条件的报表在源页面生成更灵活",
    catalogGo: "前往导出",
    generate: "生成 CSV",
    generating: "生成中…",
    runnableDone: "《{{name}}》已生成，共 {{rows}} 行",
    runnableFailed: "报表生成失败，请稍后重试",
    historyTitle: "导出任务历史",
    historySub: "记录每一次报表导出与续期提醒推送的操作人、时间与数量，默认按月归档，支持按分类 / 导出人 / 时间翻查。",
    historyExport: "导出历史",
    historyCount: "{{count}} 次 · 累计 {{rows}} 行",
    historyFilterAll: "全部记录",
    historyFilterRenewal: "只看推送留痕",
    historyAllCategory: "全部分类",
    historyAllExporter: "全部导出人",
    historyClear: "清除筛选",
    historyExpandAll: "全部展开",
    historyCollapseAll: "全部收起",
    historyMonthSummary: "{{count}} 次 · 累计 {{rows}} 行",
    historyEmpty: "还没有导出任务",
    historyEmptyDesc: "在上方生成任意报表，或在客户管理页推送续期提醒后，这里会记下每一次的操作人与时间。",
    historyNoMatch: "当前筛选条件下没有记录",
    historyNoMatchDesc: "试试放宽分类、导出人或时间范围。",
    colTime: "导出时间",
    colExporter: "导出人",
    colReport: "报表名称",
    colCategory: "分类",
    colRows: "导出行数",
    historyWindowTag: "窗口：{{window}}",
    unknown: "未知",
    others: "其他",
    rangeAll: "全部时间",
    rangeToday: "今天",
    range7d: "近 7 天",
    range30d: "近 30 天",
    catLicense: "许可证",
    catCode: "激活码",
    catCustomer: "客户",
    catAudit: "审计",
    catMonitor: "监控",
    catBatch: "批量",
  },
  apply: {
    breadcrumbHome: "首页",
    breadcrumbCurrent: "授权申请",
    title: "提交授权申请",
    subtitle: "填写产品、版本、席位与机器码等信息，提交后即可进入审批流程，全程可在许可证中心跟踪。",
    flowTitle: "申请流程",
    step1Title: "填写申请",
    step1Desc: "选择产品与版本，填写席位、机器码等信息",
    step2Title: "平台审核",
    step2Desc: "1-2 个工作日内完成资料核验",
    step3Title: "生成许可证",
    step3Desc: "审批通过后自动签发专属许可证密钥",
    step4Title: "下载激活",
    step4Desc: "在许可证中心下载并激活设备",
    tipsTitle: "温馨提示",
    tip1: "机器码可在目标设备的软件授权信息中查看",
    tip2: "席位数量按实际部署设备数填写",
    tip3: "企业版授权建议在备注中说明规模",
    tip4: "审批结果将通过填写的邮箱通知",
    helpTitle: "需要帮助？",
    helpDesc: "不确定该选择哪个版本或如何填写，可先浏览产品中心查看详细版本说明。",
    browseProducts: "浏览软件产品中心",
    infoTitle: "授权信息",
    archivedTitle: "该产品已停止授权",
    archivedDesc: "「{{name}}」已下架，暂不支持新的授权申请；你此前的相关申请仍可在下方「我的申请」中查看。请从下方推荐里选一款在售产品，或改选其它产品。",
    product: "授权产品",
    productPlaceholder: "请选择产品",
    productLoading: "加载中…",
    version: "产品版本",
    versionPlaceholder: "请选择版本",
    versionFirst: "请先选择产品",
    edition: "版本类型",
    seats: "授权席位",
    seatsPlaceholder: "例如 10",
    machine: "机器码",
    machinePlaceholder: "MC-XXXX-XXXX",
    machineHint: "可在软件「帮助 - 授权信息」中查看设备机器码",
    useCase: "使用场景说明",
    useCasePlaceholder: "简单描述使用场景、部署环境或特殊需求，便于审批人员评估（选填）",
    applicantTitle: "申请人信息",
    name: "申请人姓名",
    namePlaceholder: "请输入姓名",
    email: "联系邮箱",
    emailPlaceholder: "you@example.com",
    company: "公司 / 组织",
    companyPlaceholder: "请输入公司或组织名称（选填）",
    reloadProducts: "重新加载",
    submit: "提交授权申请",
    submitting: "提交中…",
    footerNote: "提交后进入审批流程，可在「我的许可证」中跟踪进度。",
    delistedSuffix: "（已停止授权）",
    errors: {
      product: "请选择授权产品",
      version: "请选择产品版本",
      edition: "请选择版本类型",
      seats: "授权席位需为不小于 1 的整数",
      machine: "请填写机器码",
      name: "请填写申请人姓名",
      email: "请填写联系邮箱",
      emailFormat: "邮箱格式不正确",
      useCase: "使用场景说明不能超过 500 字",
      archived: "该产品已停止授权，无法提交申请，请选择在售产品。",
      submitFailed: "提交失败，请稍后重试",
    },
    successTitle: "授权申请已提交",
    successDesc: "我们已收到你的申请，审批结果将在 1-2 个工作日内通过邮件通知，请留意查收。",
    refLabel: "申请编号",
    copyRef: "复制编号",
    copied: "已复制",
    detailProduct: "授权产品",
    detailVersion: "产品版本",
    detailEdition: "版本类型",
    detailSeats: "授权席位",
    detailMachine: "机器码",
    detailEmail: "联系邮箱",
    seatsUnit: "{{count}} 席位",
    nextTitle: "接下来会发生什么",
    next1Title: "平台审核",
    next1Desc: "审核人员核验产品、席位与机器码信息",
    next2Title: "生成许可证",
    next2Desc: "审批通过后自动生成专属许可证密钥",
    next3Title: "下载并激活",
    next3Desc: "在「我的许可证」中下载密钥并激活设备",
    viewLicenses: "查看我的许可证",
    submitAnother: "再提交一份",
    backHome: "返回首页",
    myTitle: "我的申请",
    mySub: "实时跟踪你提交的授权申请进度。",
    pendingLabel: "待审批",
    approvedLabel: "已通过",
    rejectedLabel: "已驳回",
    stepSubmit: "提交申请",
    stepReview: "平台审核",
    stepNotify: "结果通知",
    delistedCountTitle: "有 {{count}} 个申请涉及已停止授权的产品",
    delistedCountDesc: "相关产品已下架，历史申请仍可正常查看与追溯；如仍有授权需求，请前往产品中心选择在售产品重新提交申请。",
    loginTitle: "登录后即可跟踪申请进度",
    loginDesc: "你的申请会与账号绑定，登录后可随时查看待审批、已通过或已驳回的状态。",
    loginBtn: "前往登录",
    emptyTitle: "还没有申请记录",
    emptyDesc: "在左侧填写并提交授权申请后，进度会显示在这里。",
    renewalTag: "续期申请",
    seatUnit: "{{count}} 席位",
    submittedAt: "{{date}} 提交",
    processedAt: "处理于 {{date}}",
    appNo: "申请编号",
    productsLoadFailed: "产品目录加载失败，请稍后重试",
    appsLoadFailed: "申请记录加载失败，请稍后重试",
    approvalTitle: "多级审批进度",
    approvalLevel: "第 {{current}}/{{total}} 级",
    approvalCurrentHint: "当前处于第 {{current}}/{{total}} 级 · 「{{name}}」正在审批中。",
    approvalDecisionToggle: "展开查看该级决策记录",
    approvalDecisionHint: "点击带箭头的节点，可展开查看该级的审批人与意见。",
    approvalDecisionApprover: "审批人",
    approvalDecisionNote: "意见",
    approvalDecisionNoNote: "该级未填写审批意见",
    approvalDecisionTime: "时间",
    timelineTitle: "审批历程时间轴",
    timelineToggle: "展开审批历程",
    timelineCollapse: "收起审批历程",
    timelineSubmitted: "提交授权申请",
    timelineStart: "发起多级审批",
    timelineStartDesc: "申请进入多级审批流，共 {{total}} 级。",
    timelineStepApproved: "第 {{order}} 级通过 · {{name}}",
    timelineStepRejected: "第 {{order}} 级驳回 · {{name}}",
    timelineIssued: "审批全部通过 · 许可证已签发",
    timelineIssuedDesc: "许可证已生成并可下载使用。",
    timelineRejected: "审批未通过 · 流程结束",
    timelineRejectedDesc: "该申请已被驳回，流程到此结束。",
    timelinePending: "当前进行中",
    timelinePendingDesc: "当前处于第 {{current}}/{{total}} 级 · 「{{name}}」正在审批中。",
    timelineExportText: "导出文本",
    timelineExportCsv: "导出 CSV",
    timelineExportTitle: "把整条审批历程导出为文件，便于存档或发给支持团队",
    timelineExportDone: "审批历程已导出",
    timelineExportFileName: "审批历程",
    timelineColTime: "时间",
    timelineColEvent: "事件",
    timelineColApprover: "审批人",
    timelineColNote: "意见",
  },
  products: {
    breadcrumbHome: "首页",
    badge: "软件产品中心",
    title: "可授权的正版软件与版本",
    subtitle: "浏览平台已上架的正版软件，查看版本历史与授权类型，选择合适的版本一键提交授权申请。",
    searchPlaceholder: "搜索软件名称、分类或简介…",
    clearSearch: "清除搜索",
    totalUnit: "共 {{count}} 款",
    sortLabel: "排序方式",
    sortRecommend: "推荐排序",
    sortRating: "评分最高",
    sortDownloads: "授权量最多",
    sortVersion: "最新版本",
    categoryAll: "全部",
    emptyTitle: "没有找到匹配的产品",
    emptyDesc: "试试更换关键词，或切换其它分类。",
    resetFilter: "重置筛选",
    reload: "重新加载",
    loadFailed: "产品目录加载失败，请稍后重试",
    downloadsUnit: "{{count}} 次授权",
    versionsUnit: "{{count}} 个版本",
    latest: "最新 {{version}}",
    versionDetail: "版本详情",
    apply: "申请授权",
    editionsTitle: "可授权版本类型",
    customQuote: "定制报价",
    perSeat: "每席位 / 年",
    customPlan: "按需定制授权方案",
    versionHistory: "版本历史",
    close: "关闭",
    closeDetail: "关闭详情",
    applyThis: "申请该产品授权",
    recSameCategory: "同分类（{{category}}）在售产品推荐",
    recGeneric: "在售产品推荐",
  },
  notifications: {
    breadcrumbHome: "首页",
    title: "通知中心",
    subtitle: "审批结果、许可证续期与到期提醒都会在这里汇总，方便你随时掌握授权动态。",
    markAllRead: "全部标为已读",
    unread: "未读",
    emptyTitle: "暂时没有通知",
    emptyDesc: "当你提交的授权申请有审批结果，或许可证到期与续期时，通知会出现在这里。",
    viewLicenses: "查看我的许可证",
    loadFailed: "通知加载失败，请稍后重试",
    reload: "重新加载",
  },
  settings: {
    breadcrumbHome: "首页",
    title: "个人设置",
    subtitle: "管理你的账号资料与登录安全，修改昵称、公司信息以及登录密码。",
    loading: "正在加载账号资料",
    securityTitle: "安全建议",
    securityTip1: "使用包含字母、数字和符号的高强度密码",
    securityTip2: "不要在多个平台重复使用同一密码",
    securityTip3: "许可证密钥属于敏感信息，请勿公开分享",
    quickTitle: "快捷入口",
    quickLicenses: "我的许可证",
    quickApply: "提交授权申请",
    profileBasic: "基本资料",
    profileName: "昵称 / 姓名",
    profileNamePlaceholder: "请输入昵称或姓名",
    profileCompany: "公司 / 组织",
    profileCompanyPlaceholder: "请输入公司或组织名称",
    profileEmail: "登录邮箱（不可修改）",
    profileCreated: "注册时间",
    profileSave: "保存修改",
    profileSaving: "保存中…",
    profileUnsaved: "有未保存的修改",
    profileUpdated: "个人资料已更新",
    profileNameRequired: "请填写昵称",
    profileUnnamed: "未命名用户",
    roleCustomer: "普通用户",
    roleAdmin: "管理员",
    passwordTitle: "账号安全",
    showPassword: "显示密码",
    hidePassword: "隐藏密码",
    currentPassword: "当前密码",
    currentPasswordPlaceholder: "请输入当前登录密码",
    newPassword: "新密码",
    newPasswordPlaceholder: "至少 6 位",
    confirmPassword: "确认新密码",
    confirmPasswordPlaceholder: "再次输入新密码",
    updatePassword: "更新密码",
    updatingPassword: "更新中…",
    passwordUpdated: "登录密码已更新",
    errCurrent: "请输入当前密码",
    errMin: "新密码至少需要 6 位",
    errMismatch: "两次输入的新密码不一致",
    errSame: "新密码不能与当前密码相同",
    errFailed: "密码修改失败",
    saveFailed: "保存失败，请稍后重试",
  },
  apikeys: {
    breadcrumbHome: "首页",
    breadcrumbAdmin: "管理后台",
    badge: "开放平台 · 接入治理",
    title: "对接方管理",
    subtitle: "为接入校验接口的应用签发 API Key，配置限流与每日配额，并查看每一次调用日志。",
    backToAdmin: "返回管理后台",
    reload: "重新加载",
    docs: "查看接入文档",
    statClients: "对接方",
    statActiveKeys: "有效密钥",
    statCalls24h: "24h 调用",
    statErrorRate: "24h 失败率",
    usageTitle: "调用洞察",
    usageSub: "近 14 天调用趋势与对接方调用量排行，一眼看清谁在用、高峰在哪。",
    usageSubWithDays: "近 {{days}} 天调用趋势与对接方调用量排行，一眼看清谁在用、高峰在哪。",
    usageWindowShort: "{{days}} 天",
    usageWindowTotal: "近 {{days}} 天共 {{count}} 次",
    trendTitle: "近 {{days}} 天调用趋势",
    trendLegendOk: "成功",
    trendLegendFail: "失败",
    trendLegendBlocked: "被限流",
    trendDayTotal: "{{count}} 次",
    trendPeak: "单日峰值 {{count}} 次",
    trendEmpty: "暂无调用数据",
    rankTitle: "对接方调用量排行",
    rankTotal: "共 {{count}} 次",
    rankEmpty: "暂无可排行的对接方",
    rankCalls: "{{count}} 次",
    rankShare: "占 {{pct}}%",
    rankBlocked: "被拦 {{count}}",
    rankShowAll: "展开全部 {{count}} 个",
    rankCollapse: "收起",
    rankClickHint: "点对接方即可筛选下方调用日志",
    rankActive: "已筛选",
    policyTitle: "校验接口鉴权策略",
    policySub: "在「强制 Key」与「过渡兼容」之间切换，用于平滑迁移旧客户端。",
    policyRequired: "强制 Key",
    policyOptional: "过渡兼容",
    policyCurrent: "当前策略",
    policyRequiredDesc: "所有请求必须携带有效 API Key，否则返回 401；未携带的请求也会被记入调用日志。",
    policyRequiredWarn: "旧版未携带 Key 的客户端会立即收到 401，请先为它们签发密钥再切换。",
    policyOptionalDesc: "未携带 API Key 的请求将被放行（不记录归属），携带 Key 的请求照常鉴权与限流。",
    policyOptionalWarn: "过渡兼容模式下，无 Key 请求不受限流约束，也无法归属到具体对接方，建议仅在迁移期短期开启。",
    policySwitched: "鉴权策略已更新",
    policySwitchFailed: "策略更新失败，请稍后重试",
    policyConfirmTitle: "确认切换鉴权策略？",
    policyConfirmToRequired: "切换后所有未携带 x-api-key 的请求将立即收到 401。请先确认已为存量客户端签发密钥并完成升级。",
    policyConfirmToOptional: "切换后未携带 API Key 的请求将被放行（不记录归属、不受限流约束）。建议仅在迁移期短期开启。",
    policyConfirmBtn: "确认切换",
    policyHistoryTitle: "策略变更历史",
    policyHistorySub: "回看每一次鉴权策略的调整，含操作人与前后方向，便于误切回溯。",
    policyHistoryEmpty: "暂无策略变更记录",
    policyHistoryEmptyDesc: "切换鉴权策略后，每一次调整都会记录在这里。",
    logCopyPrefixes: "复制全部密钥前缀",
    logCopyPrefixesTitle: "复制该对接方名下所有密钥前缀，便于批量核对",
    logCopyPrefixesEmpty: "该对接方暂无可复制的密钥",
    logCopiedPrefixes: "已复制 {{count}} 个前缀",
    logKeyAll: "全部密钥",
    logKeyFilterLabel: "密钥下钻",
    logKeyDetailTitle: "下钻密钥",
    logKeyCalls: "窗口内调用",
    clientsTitle: "对接应用",
    clientsSub: "每个应用可签发多把密钥，密钥按应用维度统一管理。",
    createClient: "新建对接方",
    noClient: "还没有对接方",
    noClientDesc: "新建一个对接方后即可为其签发 API Key。",
    clientKeys: "{{count}} 把密钥",
    clientLastUsed: "最近调用 {{time}}",
    clientNeverUsed: "尚未调用",
    suspended: "已暂停",
    activeStatus: "启用中",
    suspend: "暂停接入",
    resume: "恢复接入",
    edit: "编辑",
    delete: "删除",
    addKey: "签发密钥",
    noKey: "该对接方还没有密钥",
    keyName: "密钥名称",
    keyPrefix: "密钥前缀",
    keyRate: "限流",
    keyQuota: "每日配额",
    keyStatus: "状态",
    keyLastUsed: "最近调用",
    keyExpires: "到期",
    keyNever: "从未",
    keyUnlimited: "不限",
    keyPermanent: "永久",
    rateUnit: "{{count}} 次/分钟",
    quotaUnit: "{{count}} 次/日",
    revoke: "吊销",
    enable: "启用",
    keyRevokedStatus: "已吊销",
    keyActiveStatus: "有效",
    confirmDeleteClient: "删除该对接方将同时删除其全部密钥，确定继续？",
    confirmDeleteKey: "确定删除这把密钥？此操作不可恢复。",
    newClientTitle: "新建对接方",
    editClientTitle: "编辑对接方",
    fieldName: "对接方名称",
    fieldNamePlaceholder: "例如 星河桌面客户端",
    nameRequired: "请填写对接方名称",
    fieldOwner: "负责人",
    fieldOwnerPlaceholder: "例如 星河软件 · 李工",
    fieldEmail: "联系邮箱",
    fieldEmailPlaceholder: "ops@example.com",
    fieldDesc: "用途说明",
    fieldDescPlaceholder: "简单说明该应用如何接入校验接口（选填）",
    cancel: "取消",
    save: "保存",
    saving: "保存中…",
    create: "创建",
    newKeyTitle: "签发 API Key",
    newKeySubtitle: "为该对接方签发一把新的 API Key。",
    keyIssuedTitle: "API Key 已生成",
    keyIssuedDesc: "请立即复制并妥善保存，出于安全考虑，明文密钥仅此一次展示。",
    copyKey: "复制密钥",
    copied: "已复制",
    done: "我已保存",
    fieldRate: "限流（次/分钟）",
    fieldQuota: "每日配额（次/日，0 表示不限）",
    fieldExpires: "到期时间（选填）",
    keyNameDefault: "默认密钥",
    logsTitle: "调用日志",
    logsSub: "记录每一次校验接口调用的对接方、密钥、结果与耗时，便于排障与对账。",
    logClientAll: "全部对接方",
    logStatusAll: "全部结果",
    logStatusOk: "成功",
    logStatusFail: "失败",
    logStatusBlocked: "被限流",
    logRangeAll: "全部时间",
    logRangeToday: "今天",
    logRange24h: "近 24 小时",
    logRange7d: "近 7 天",
    logClear: "清除筛选",
    logShowAll: "展开全部 {{count}} 条",
    logCollapse: "收起",
    logExport: "导出调用日志",
    logEmpty: "暂无调用日志",
    logEmptyDesc: "对接方调用校验接口后，这里会记录每一次请求。",
    logNoMatch: "当前筛选条件下没有日志",
    logNoMatchDesc: "试试放宽对接方、结果或时间范围。",
    colTime: "时间",
    colClient: "对接方",
    colKey: "密钥",
    colLicense: "许可证",
    colResult: "结果",
    colLatency: "耗时",
    colIp: "来源 IP",
    latencyUnit: "{{ms}} ms",
    resultOk: "成功",
    unknown: "未知",
    loadFailed: "对接方数据加载失败，请稍后重试",
    actionFailed: "操作失败，请稍后重试",
    created: "对接方已创建",
    updated: "对接方已更新",
    deleted: "对接方已删除",
    statusChanged: "对接方状态已更新",
    keyCreated: "API Key 已签发",
    keyUpdated: "密钥配置已更新",
    keyRevoked: "密钥已吊销",
    keyEnabled: "密钥已启用",
    keyDeleted: "密钥已删除",
    exported: "已导出 {{count}} 条调用日志",
  },
  approvals: {
    breadcrumbHome: "首页",
    breadcrumbAdmin: "管理后台",
    badge: "审批治理 · 事件回调",
    title: "审批流与事件回调",
    subtitle: "配置可级联的多级审批流、逐级处理待审批申请并自动发证，同时把授权事件回调（Webhook）投递到你的业务系统。",
    backToAdmin: "返回管理后台",
    reload: "重新加载",
    tabFlow: "审批流",
    tabWebhook: "事件回调",
    statWorkflows: "审批流",
    statPending: "进行中审批",
    statDone: "已结束审批",
    statEndpoints: "回调端点",
    workflowsTitle: "审批流配置",
    workflowsSub: "按席位门槛匹配审批流，逐级流转，终审通过自动发证。",
    newWorkflow: "新建审批流",
    editWorkflow: "编辑审批流",
    workflowsEmpty: "还没有配置审批流",
    workflowsEmptyDesc: "新建一条审批流后，即可为待审批申请发起多级审批。",
    enabled: "已启用",
    disabled: "已停用",
    minSeatsTag: "席位 ≥ {{count}}",
    allSeatsTag: "不限席位",
    edit: "编辑",
    delete: "删除",
    roleAdmin: "超管",
    roleStaff: "客服",
    fieldName: "审批流名称",
    fieldNamePlaceholder: "例如 标准两级审批",
    fieldDesc: "说明",
    fieldDescPlaceholder: "简单说明这条审批流的适用场景（选填）",
    fieldMinSeats: "适用席位门槛",
    fieldMinSeatsHint: "席位达到该值及以上的申请才会匹配本审批流。",
    fieldEnabled: "状态",
    stepsLabel: "审批节点（按顺序逐级流转）",
    addStep: "添加一级",
    stepNamePlaceholder: "节点名称，例如 商务复核",
    stepDefaultFirst: "客服初审",
    save: "保存",
    saving: "保存中…",
    cancel: "取消",
    workflowNameRequired: "请填写审批流名称",
    workflowStepsRequired: "请至少配置一个审批节点",
    workflowCreated: "审批流已创建",
    workflowUpdated: "审批流已更新",
    workflowDeleted: "审批流已删除",
    deleteWorkflow: "删除审批流",
    confirmDeleteWorkflow: "删除该审批流会同时移除其审批节点，已发起的审批请求不受影响。确定继续？",
    requestDelete: "删除",
    saveFailed: "保存失败，请稍后重试",
    actionFailed: "操作失败，请稍后重试",
    pendingStartTitle: "待发起审批",
    pendingStartSub: "这些待审批申请还没有进入审批流，选择一条即可发起多级审批。",
    pendingStartEmpty: "暂无待发起审批的申请。",
    startApproval: "发起审批",
    startSuccess: "已发起多级审批",
    requestsTitle: "审批请求",
    requestsSub: "逐级流转的审批请求，展示当前进度与每一级的决策记录。",
    requestsCount: "共 {{count}} 条",
    requestsEmpty: "暂无审批请求。",
    statusPending: "进行中",
    statusApproved: "已通过",
    statusRejected: "已驳回",
    seatUnit: "{{count}} 席位",
    renewalTag: "续期申请",
    submittedAt: "{{date}} 提交",
    unknown: "未知",
    currentStep: "当前节点",
    approve: "通过",
    reject: "驳回",
    approveTitle: "确认通过本级审批？",
    rejectTitle: "确认驳回该申请？",
    approveDesc: "通过后如还有下一级将流转给下一级审批人；若为最后一级则自动签发 / 续期许可证并通知申请人。",
    rejectDesc: "驳回后该申请将结束流转并标记为已驳回，申请人会收到通知。",
    noteLabel: "审批意见（选填）",
    notePlaceholder: "填写审批意见或驳回原因…",
    confirm: "确认",
    approveSuccess: "已通过本级审批",
    rejectSuccess: "已驳回该申请",
    endpointsTitle: "回调端点",
    endpointsSub: "订阅授权事件，投递到你的业务系统；带上签名密钥即可校验来源。",
    newEndpoint: "新建端点",
    editEndpoint: "编辑端点",
    endpointsEmpty: "还没有配置回调端点。",
    endpointEnabled: "已启用",
    endpointPaused: "已暂停",
    endpointStatusChanged: "端点状态已更新",
    signedTag: "已签名",
    test: "测试",
    pause: "暂停",
    resume: "恢复",
    delete: "删除",
    endpointName: "端点名称",
    endpointNamePlaceholder: "例如 订单系统回调",
    endpointUrl: "回调地址",
    endpointSecret: "签名密钥（选填）",
    endpointSecretPlaceholder: "用于 HMAC-SHA256 签名，留空则不签名",
    endpointSecretHint: "校验请求头 x-licensehub-signature（对请求体做 HMAC-SHA256）。",
    endpointEvents: "订阅事件",
    endpointNameRequired: "请填写端点名称",
    endpointUrlRequired: "回调地址需以 http:// 或 https:// 开头",
    endpointEventsRequired: "请至少订阅一个事件",
    endpointCreated: "回调端点已创建",
    endpointUpdated: "回调端点已更新",
    endpointDeleted: "回调端点已删除",
    confirmDeleteEndpoint: "删除该端点会同时移除其投递记录，确定继续？",
    event_approval_step_approved: "审批单级通过（流转到下一级）",
    event_approval_completed: "审批终审通过（已发证）",
    event_approval_rejected: "审批被驳回",
    deliveriesTitle: "投递日志",
    deliveriesSub: "每一次事件回调的投递结果，失败可一键重试。",
    deliveryAllEndpoints: "全部端点",
    deliveriesEmpty: "暂无投递记录。",
    deliverySuccess: "成功",
    deliveryFailed: "失败",
    deliveryPending: "待投递",
    colDeliveryTime: "投递时间",
    colEndpoint: "端点",
    colEvent: "事件",
    colDeliveryStatus: "结果",
    colAttempts: "尝试",
    colResponse: "响应",
    colActions: "操作",
    retry: "重试",
    testDone: "测试投递成功",
    testFailed: "测试投递失败：{{error}}",
    retryDone: "重试投递成功",
    stepSlaLabel: "超时提醒时限（小时）",
    stepEscalateLabel: "超时自动升级时限（小时）",
    stepTimeoutHint: "超过提醒时限发站内提醒；启用升级时限后，再超时自动升级到下一级（0 表示不自动升级）。",
    stepSlaChip: "{{hours}} 小时后提醒审批人",
    stepEscalateChip: "{{hours}} 小时后自动升级到下一级",
    timeoutHint: "进入本页会自动巡检一次；也可手动检查哪些审批节点已超时，并按规则提醒 / 升级。",
    checkTimeouts: "立即检查超时",
    timeoutNone: "暂无超时的审批节点",
    timeoutResult: "超时巡检完成：提醒 {{reminded}} 条 · 自动升级 {{escalated}} 条",
    overdueTag: "已超时 {{hours}}h",
    escalatedTag: "已升级",
    remindedTag: "已提醒",
    useBuiltinReceiver: "使用内置验证接收端",
    builtinReceiverHint: "内置接收端会自动校验签名头 x-licensehub-signature 与事件负载格式，结果可在下方投递日志的「响应」列查看。",
    deliveryRetrying: "重试中",
    endpointSuccessRate: "投递成功率",
    endpointStatTotal: "共 {{count}} 次",
    autoRetryHint: "投递失败会按指数退避自动重试（30s / 2m / 8m，最多 4 次），进入本页会自动处理一次到期的重试。",
    processRetries: "处理待重试投递",
    retriesNone: "暂无到期的待重试投递",
    retriesProcessed: "已处理 {{processed}} 条待重试投递（成功 {{succeeded}} 条）",
    retryScheduled: "{{time}}后自动重试",
    bulkTimeoutTitle: "整体默认时限",
    bulkTimeoutHint: "填一次，一键应用到全部节点",
    bulkSlaLabel: "提醒时限（小时）",
    bulkEscalateLabel: "升级时限（小时）",
    bulkApply: "应用到全部节点",
    bulkTimeoutApplied: "已将时限应用到全部 {{count}} 个节点",
    healthTitle: "端点健康总览",
    healthSub: "汇总每个接收端的成功率、平均响应耗时与最近一次投递，最不稳定的排在前面。",
    healthEmpty: "暂无端点可统计。",
    healthColEndpoint: "接收端",
    healthColRate: "投递成功率",
    healthColLatency: "平均响应耗时",
    healthColTotal: "投递次数",
    healthColFailed: "失败",
    healthColLast: "最近一次投递",
    healthLeastStable: "最不稳定",
    healthNoDelivery: "暂无投递",
    healthAvgUnit: "{{ms}} ms",
    healthWindowLabel: "时间窗口",
    healthWindow24h: "近 24 小时",
    healthWindow7d: "近 7 天",
    healthWindow30d: "近 30 天",
    healthWindowHint: "只看所选窗口内的投递表现，方便聚焦近期变差的接收端。",
    autoDegradeHint: "端点连续失败达 {{threshold}} 次会自动暂停并通知管理员，避免空转刷日志。",
    endpointConsecutive: "连续失败 {{count}} 次",
    endpointAutoPaused: "已自动暂停",
    endpointNeedsAttention: "建议检查接收端",
    endpointNeedsAttentionHint: "该端点恢复后补投已连续多次失败，建议先排查接收端再恢复，避免反复复位",
    markFixed: "标记已修复",
    markFixedTitle: "确认接收端已修复，一键清除「建议检查接收端」降级标记并清零恢复后失败次数",
    markFixedDone: "已标记为修复，降级标记已清除",
    undoMarkFixed: "撤销标记已修复",
    undoMarkFixedTitle: "误标了？一键还原「建议检查接收端」降级标记与恢复后失败次数",
    undoMarkFixedDone: "已撤销标记，降级标记已恢复",
    recoverPrecheck: "预检并恢复",
    recoverPrecheckRunning: "预检中…",
    recoverPrecheckOk: "预检通过，端点已恢复",
    recoverPrecheckFail: "预检未通过，端点保持暂停：{{error}}",
    recoverPrecheckTitle: "恢复前先发一条测试投递，通过才真正启用，避免刚恢复又立刻再次连败",
    recoverPrecheckHint: "对「已自动暂停」的端点，点「预检并恢复」会先发一条测试投递，通过后才重新启用，并自动补投全部待重试投递。",
    recoverPrecheckReplayOk: "预检通过，端点已恢复，并已自动补投 {{count}} 条待重试投递",
    recoverPrecheckReplayFail: "预检通过，端点已恢复，补投 {{count}} 条中 {{success}} 条成功，其余可稍后手动重试",
    recoverPrecheckDegraded: "预检通过，但恢复后补投仍连续失败（本轮 {{count}} 条），建议先检查接收端再恢复，避免反复复位",
    exportHealth: "导出健康快照 CSV",
    exportHealthTitle: "把当前时间窗口下每个接收端的成功率 / 平均耗时 / 失败数导出为 CSV",
    exportHealthFileName: "端点健康快照",
    exportEvents: "导出事件历史 CSV",
    exportEventsTitle: "把当前筛选出的端点健康事件（自动暂停 / 恢复 / 预检 / 清零）导出为 CSV 存档",
    exportEventsFileName: "端点健康事件历史",
    eventColTime: "时间",
    eventColType: "事件类型",
    eventColEndpoint: "接收端",
    eventColDetail: "说明",
    eventColActor: "操作人",
    healthEventTitle: "健康事件时间线",
    healthEventSub: "记录每次自动暂停 / 手动恢复 / 连续失败清零的时间与原因，便于事后追溯。",
    healthEventEmpty: "暂无健康事件记录。",
    eventAutoPaused: "自动暂停",
    eventManualResume: "手动恢复",
    eventManualPause: "手动暂停",
    eventFailuresReset: "连续失败清零",
    eventProbePassed: "预检通过",
    eventProbeFailed: "预检未通过",
    eventResumeReplay: "恢复后补投",
    eventReplayDegraded: "补投连续失败",
    eventMarkedFixed: "标记已修复",
    eventUndidFixed: "撤销标记已修复",
    healthEventAllEndpoints: "全部端点",
    healthEventAllTypes: "全部事件",
    healthEventNoMatch: "当前筛选条件下没有健康事件。",
  },
  helpFeedback: {
    breadcrumbHome: "首页",
    breadcrumbAdmin: "管理后台",
    badge: "帮助内容质量",
    title: "帮助中心反馈",
    subtitle: "汇总客户对常见问题解答的「有帮助 / 没帮助」反馈，找出最需要补充或改写的内容，优先完善高频困惑。",
    backToAdmin: "返回管理后台",
    reload: "重新加载",
    loadFailed: "反馈数据加载失败，请稍后重试",
    statFeedback: "反馈总数",
    statHelpful: "有帮助",
    statNotHelpful: "没帮助",
    statRate: "没帮助占比",
    topTitle: "最需要补充的内容",
    topSub: "按「没帮助」次数从高到低排序，排在前面的解答建议优先改写。",
    topEmpty: "还没有「没帮助」反馈",
    topEmptyDesc: "当客户标记某条解答「没帮助」后，会在这里按次数排出来。",
    notHelpfulUnit: "{{count}} 次没帮助",
    helpfulUnit: "{{count}} 次有帮助",
    tableTitle: "全部反馈明细",
    tableSub: "按问题维度汇总每一条解答的有帮助 / 没帮助次数与占比。",
    colQuestion: "问题",
    colCategory: "分类",
    colHelpful: "有帮助",
    colNotHelpful: "没帮助",
    colRate: "没帮助占比",
    colTotal: "反馈数",
    colLast: "最近反馈",
    colStatus: "状态",
    exportTop: "导出 CSV",
    optimizeBadge: "待优化",
    resolvedBadge: "已完善",
    optimizeCount: "{{count}} 条待优化",
    markResolved: "标记已完善",
    unmarkResolved: "撤销已完善",
    onlyOptimize: "只看待优化",
    statusOptimize: "待优化",
    statusResolved: "已完善",
    statusWatching: "观察中",
    previewTitle: "在新窗口预览该问题答案",
    sortNotHelpful: "按没帮助",
    sortRate: "按占比",
    sortTotal: "按反馈数",
    allCategories: "全部分类",
    noCategory: "未分类",
    unknownQuestion: "未知问题",
    totalUnit: "共 {{count}} 条反馈",
    empty: "暂无反馈数据",
    emptyDesc: "客户在帮助中心标记「有帮助 / 没帮助」后，会汇总在这里。",
    colNote: "优化备注",
    colOwner: "负责人",
    editAnswer: "编辑答案",
    editTitle: "编辑问答内容",
    editSub: "直接修改这条 FAQ 的中英文问答，保存后立即对所有访客生效，无需改动代码。字段留空则沿用默认文案。",
    contentPreview: "预览当前答案",
    contentFieldEmpty: "留空的字段会沿用内置默认文案",
    contentLangZh: "中文",
    contentLangEn: "English",
    contentQuestion: "问题",
    contentAnswer: "解答",
    contentSave: "保存并发布",
    contentSaving: "保存中…",
    contentReset: "重置为默认",
    contentCancel: "取消",
    contentEditedBadge: "已改",
    tabEdit: "编辑内容",
    tabHistory: "版本历史",
    draftBadge: "有草稿",
    saveDraft: "存草稿",
    publish: "发布",
    diffTitle: "改动对比",
    diffCount: "{{count}} 处改动",
    diffNoChange: "暂无改动",
    diffBefore: "改动前",
    diffAfter: "改动后",
    diffToggle: "查看对比",
    diffDefault: "（默认文案）",
    versionsEmpty: "暂无版本记录",
    versionsEmptyDesc: "保存或发布一次后，这里会留下每条变更记录，可随时回滚。",
    unknownEditor: "未知用户",
    actionPublish: "发布",
    actionDraft: "存草稿",
    actionReset: "重置默认",
    actionRollback: "回滚",
    rollback: "回滚到此版本",
    resolveTitle: "标记已完善",
    resolveHint: "记录这次改了哪里、由谁负责，形成内容优化台账，方便后续回看与交接。",
    resolveNoteLabel: "优化备注",
    resolveNotePlaceholder: "例如：补充了机器码查看路径与截图说明",
    resolveOwnerLabel: "负责人",
    resolveOwnerPlaceholder: "例如：内容组 · 小王",
    resolveConfirm: "标记已完善",
    resolveSaving: "保存中…",
    settingsTitle: "「待优化」判定规则",
    settingsSub: "自定义什么算「没帮助占比过高」。同时满足占比与条数两条门槛的 FAQ，才会被自动标记为「待优化」。",
    settingsRateLabel: "没帮助占比阈值",
    settingsRateHint: "没帮助数 ÷ 反馈总数 达到该比例才计入",
    settingsMinLabel: "最少没帮助条数",
    settingsMinHint: "累计达到该条数才计入，避免单条噪音误报",
    settingsSave: "保存规则",
    settingsSaving: "保存中…",
    settingsCurrent: "当前规则：占比 ≥ {{rate}}% 且没帮助 ≥ {{min}} 条",
    ledgerTitle: "内容优化台账",
    ledgerSub: "已完善的 FAQ、改了哪里、由谁负责、谁标记的，一目了然。",
    ledgerEmpty: "还没有优化记录",
    ledgerEmptyDesc: "把「待优化」的问题标记为已完善后，记录会汇总到这里。",
    ledgerCount: "{{count}} 条已完善",
    ledgerColQuestion: "问题",
    ledgerColNote: "优化备注",
    ledgerColOwner: "负责人",
    ledgerColBy: "标记人",
    ledgerColAt: "标记时间",
    ledgerColAction: "操作",
    ledgerEditNote: "改备注",
    ledgerUndo: "撤销已完善",
    ledgerNoNote: "未填写备注",
    notePrefix: "备注",
    ownerPrefix: "负责人",
    markedBy: "由 {{name}} 标记",
    weeklyExport: "导出周报",
    weeklyExportTitle: "导出内容优化周报 CSV（含每位负责人的待优化 / 已完善工作量）",
    weeklyTitle: "内容优化周报",
    weeklyOwnerSection: "负责人工作量汇总",
    weeklyColOwner: "负责人",
    weeklyColPending: "待优化",
    weeklyColResolved: "已完善",
    weeklyColTotal: "合计",
    weeklyColQuestions: "涉及 FAQ",
    weeklyColStatus: "状态",
    weeklyDetailSection: "待优化 / 已完善明细",
    weeklyUnassigned: "未分配",
    weeklyPendingChip: "待优化 {{count}}",
    weeklyResolvedChip: "已完善 {{count}}",
    filterEditor: "操作人",
    filterAction: "动作",
    filterAllEditors: "全部操作人",
    filterAllActions: "全部动作",
    exportLedger: "导出变更台账",
    exportLedgerTitle: "把当前筛选出的变更记录导出为 CSV，便于月度留痕归档",
    ledgerColTime: "时间",
    ledgerColQuestion: "问题",
    ledgerColEditor: "操作人",
    ledgerColAction: "操作",
    ledgerColFields: "变更字段",
    versionFilterEmpty: "当前筛选下没有版本记录",
    onlyDraft: "仅看有草稿",
    batchPublish: "一键批量发布",
    batchPublishCount: "一键发布 {{count}} 条草稿",
    batchPublishTitle: "确认批量发布草稿",
    batchPublishDesc: "以下 {{count}} 条 FAQ 的草稿将立即对访客生效：",
    batchPublishConfirm: "确认发布",
    batchPublishing: "发布中…",
    batchPublishDone: "已发布 {{count}} 条草稿",
    draftOnlyEmpty: "当前没有待发布的草稿",
    draftOnlyEmptyDesc: "运营保存草稿后，会在这里集中列出，方便一次性上线。",
    tip: "「没帮助」占比较高的解答，建议结合对应分类的工单内容，补写更具体的操作步骤或截图说明。",
  },
};